import React, { useRef, useState } from "react";
import { jsPDF } from "jspdf";
import html2canvas from "html2canvas";
import { QRCodeCanvas } from "qrcode.react";

export default function License() {
    const pdfRef = useRef();
    const [pdfUrl, setPdfUrl] = useState("https://example.com/mydocument.pdf"); // Change to your actual document URL
  
    const generatePDF = () => {
      const input = pdfRef.current;
      html2canvas(input).then((canvas) => {
        const imgData = canvas.toDataURL("image/png");
        const pdf = new jsPDF("p", "mm", "a5");
        const imgWidth = 150;
        const imgHeight = (canvas.height * imgWidth) / canvas.width;
        pdf.addImage(imgData, "PNG", 0, 0, imgWidth, imgHeight);
  
        // Convert QR Code to Image
        const qrCanvas = document.getElementById("qrCode");
        const qrImg = qrCanvas.toDataURL("image/png");
  
        // Add QR Code to PDF
        // pdf.addImage(qrImg, "PNG", 75, imgHeight + 10, 50, 50); // Position below content
  
        // Save and Open PDF
        // pdf.save("document_with_qr.pdf");
        const pdfBlob = pdf.output("blob");
        const pdfBlobUrl = URL.createObjectURL(pdfBlob);
        window.open(pdfBlobUrl, "_blank");
      });
    };
  return (
    <div style={{ textAlign: "center", width:'70%' }}>
      <h2>Generate PDF with QR Code</h2>
      
      {/* Content to Export */}
      <div ref={pdfRef} style={{ padding: 20, background: "white"}}>
      <div className="licenseBody" style={{border:'1px solid black',marginLeft:'1%',marginRight:'2%'}}>
        <img src="/sautilogo.png" alt="" className="licenseLogo" />
        <h2 className="licenseTitle">MUSIC LICENSE</h2>
        
        <div className="licenseContent" style={{marginLeft:'2%',marginRight:'2%'}}>
        <div className="" style={{display:'flex',justifyContent:'space-between'}}>
            <div className="">
            <p >License No: 1234</p>
            <p >Date: 3/02/2025</p>

            </div>
            <div className="">
                   

            </div>
        </div>

        <div className="licenseTable" style={{display:'flex',justifyContent:'space-between'}}>
            <div className="licenseLeft" style={{flex:6}}>
                <h6 style={{textAlign:'left'}}>THE LICENCEE</h6>
                <div className="table" style={{border:'2px solid black',padding:'10px'}}>
                    <p>Name: <span style={{textDecoration:'underline'}}>Victor Masila</span></p>
                    <hr />
                    <p>Phone: <span style={{textDecoration:'underline'}}>0797083661</span></p>
                </div>
  
            </div>
            <div className="licenseRight" style={{flex:6}}>
            <h6 style={{textAlign:'left'}}>THE TARIFF</h6>
                <div className="table" style={{border:'2px solid black',padding:'10px'}}>
                    <p>Tariff: <span style={{textDecoration:'underline'}}>PUBLIC TRANSPORT</span></p>
                    <hr />
                    <p>Amount paid: <span style={{textDecoration:'underline'}}>Kes.15000 /=</span></p>
                </div>

            </div>
        </div>
        <p>This license is issued by MUSTECH NETWORK LTD and grants the licensee the right to use the specified music under the terms outlined in the selected tariff. This license is valid only upon full payment and is non-transferable. Unauthorized use, reproduction, or distribution of the licensed music is strictly prohibited. For inquiries or further information, please contact SAYANEM. Thank you for supporting the rights of music creators.</p>
        <div className="footer" style={{display:'flex', justifyContent:'space-between'}}>
            <div className="">
            <img src="esign.png" width='150px' alt="" />
            <p>SIGN</p>

            </div>
            <div className="">
                <QRCodeCanvas id="qrCode" value={pdfUrl} size={100} />
                <p style={{textAlign:'center'}}>Scan me</p>

            </div>
        </div>
        
        
        </div>
        
      </div>

      {/* QR Code */}


      {/* Button to Generate PDF */}
      <button onClick={generatePDF}>Generate PDF with QR</button>
      </div>
    </div>
  )
}
